module.exports = __webpack_public_path__ + "img/chevrone-icon.1235e4a3.svg";